import React, { Component } from 'react'
import Handler from '../components/handler/index'

class Architecture extends Component {
  render () {
    return (
      <Handler {...this.props} />
    )
  }
}

export default Architecture



// WEBPACK FOOTER //
// ./src/pages/architecture.js